import React, { Component } from 'react';
import NoSSR from '~/src/helpers/noSSR';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Filter from '@ertelecom/ui-react/components/filter';
import Select from '@ertelecom/ui-react/components/select/select';
import Tab from '@ertelecom/ui-react/components/tabs/tab';
import Tabs from '@ertelecom/ui-react/components/tabs/tabs';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';

import { getCategories, getChannels, getSchedule } from '~/src/api/schedule';
import { createDateList, createTimeIntevals, getCurrentTimeInterval, addTimeToSchedule } from '~/src/components/Schedule/helpers';

import Layout from '~/src/layout/_layout';
import ChannelCommon from '~/src/components/Schedule/ChannelCommon';
import PageBanner from '~/src/components/Schedule/PageBanner';
import ChannelSearch from '~/src/components/Channels/search';
import * as base from '~/src/helpers/basePageFunc';

const SchedulePage = styled.div`
    background-color: ${COLORS.white};
    display: block;
    flex-grow: 1;
    width: 100%;
`;

const ScheduleContainer = styled.div`
    padding: 0 7% 30px;
    margin: 0 auto;
    max-width: 1440px;
    width: 100%;

    @media screen and (max-width: 859px) {
        padding: 0 15px 30px;
    }
`;

const ScheduleControls = styled.section`
    display: flex;
    margin-top: 32px;
    position: relative;
    width: 100%;

    @media only screen and (max-width: 1023px) {
        margin-top: 27px;
    }

    @media only screen and (max-width: 767px) {
        flex-direction: column;
        margin-top: 27px;
    }
`;

const ScheduleControlSearch = styled.div`
    flex-shrink: 0;
    margin-right: 32px;
    width: 320px;

    @media only screen and (max-width: 1023px) {
        width: calc(50% - 16px);
    }

    @media only screen and (max-width: 767px) {
        margin-right: 0;
        margin-bottom: 33px;
        width: 100%;
    }

    & > div {
        max-width: none;
    }
`;

const ScheduleControlCategory = styled.div`
    flex-shrink: 0;
    width: 290px;

    @media only screen and (max-width: 1023px) {
        width: calc(50% - 16px);
    }

    @media only screen and (max-width: 767px) {
        width: 100%;
    }
`;

const ScheduleChannels = styled.section`
    align-items: stretch;
    display: flex;
    flex-wrap: wrap;
    margin-top: 46px;
    width: 100%;
`;

const ScheduleTabs = styled.section`
    margin-top: 32px;
    width: 100%;
`;

const ScheduleShowMore = styled(StyledButton)`
    display: none;
    width: 100%;

    @media only screen and (max-width: 1023px) {
        display: inline-block;
    }
`;

const timeIntervals = createTimeIntevals();

const CHANNELS_COUNT = 12;

const channelsState = list => {
    let channelsDifference = list.length - CHANNELS_COUNT;
    if (channelsDifference < 0) {
 channelsDifference = 0;
}

    return {
        channelsDifference,
        channelsListRendered: list.slice(0, CHANNELS_COUNT),
    };
};

class Schedule extends Component {
    static async getInitialProps(options) {
        const { store } = options;
        let { query: { category } } = options;

        // Определение города
        const { headerHost } = await base.initialProps(options);

        // Получаем список категорий
        const categoriesList = await getCategories();
        categoriesList.unshift({ label: 'Категории каналов', value: '' });

        category = Number(category) || '';

        // Заполняем список дат
        const dateList = createDateList();

        const state = store.getState();
        const { city: { currentCity } } = state;

        const { domain } = currentCity;

        // Получаем массив с каналами
        const channelsList = await getChannels(category, domain);
        const channelsListRendered = channelsList.slice(0, CHANNELS_COUNT);

        // Получаем программы
        const currentTime = timeIntervals[getCurrentTimeInterval()];
        const xvidArray = channelsListRendered.map(({ xvid }) => xvid);
        const schedules = await getSchedule(xvidArray, dateList[2].start, currentTime, domain);
        const scheduleList = { ...addTimeToSchedule(schedules) };

        return {
            host: headerHost,
            category,
            categoriesList,
            dateList,
            channelsList,
            scheduleList
        };
    }

    constructor(props) {
        super(props);

        // Инпут поиска
        this.inputSearchRef = React.createRef();

        // Контейнер страницы
        this.scheduleContainer = React.createRef();

        // Идет загрузка

        this.state = {
            category: props.category,
            channelsDifference: 0,
            channelsList: props.channelsList,
            ...channelsState(props.channelsList),
            currentDate: props.dateList[2].start,
            dateList: props.dateList,
            isSearch: false,
            scheduleList: props.scheduleList,
        };

        this.setChannelsList(props.category);
    }

    componentDidMount() {

        this.setState({
            time: getCurrentTimeInterval(),
        }, this.updateSchedule);

        // Мобильная версия
        this.isMobile = window.matchMedia('(max-width: 1023px)').matches;
        if (!this.isMobile) {
 window.addEventListener('scroll', this.onWindowScroll);
}

        window.addEventListener('resize', this.onWindowResize);
    }

    async componentDidUpdate(prevProps) {
        const { city, router } = this.props;
        if (JSON.stringify(city) !== JSON.stringify(prevProps.city)) {
            this.setState({
                scheduleList: {},
            }, this.updateSchedule);
        }

        let { query: { category } } = router;
        const prevCategory = Number(prevProps.router.query.category) || '';
        category = Number(category) || '';

        if (prevCategory !== category) {
            await this.setChannelsList(category);
        }

    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onWindowScroll);
        window.removeEventListener('resize', this.onWindowResize);
    }

    setChannelsList = async category => {
        const channelsList = await getChannels(category, this.props.city.domain);
        this.setState({
            category,
            channelsList,
            ...channelsState(channelsList),
            isSearch: false,
        }, this.updateSchedule);
    };

    async updateSchedule() {
        const { currentDate, time, channelsListRendered, scheduleList } = this.state;

        const channelsWithoutSchedule = channelsListRendered
            .filter(({ xvid }) => !Object.keys(scheduleList).includes(xvid));

        if (channelsWithoutSchedule.length === 0) {
 return;
}
        this.isUpload = true;

        const xvidArray = channelsWithoutSchedule.map((channel) => channel.xvid);
        const currentTime = timeIntervals[time];

        const currentDateObject = typeof currentDate === 'string' ? new Date(currentDate) : currentDate;

        const newSchedule = await getSchedule(xvidArray, currentDateObject, currentTime, this.props.city.domain);

        this.setState(({ scheduleList }) => {
            const currentSchedule = {
                ...scheduleList,
                ...addTimeToSchedule(newSchedule),
            };

            return { scheduleList: currentSchedule };
        }, () => {
            this.isUpload = false;
        });
    }

    onCategoriesChange = async({ value }) => {
        const { router } = this.props;
        const { pathname, query } = router;

        router.push({
            pathname,
            query: value !== ''
                ?   {
                        ...query,
                        category: value,
                    }
                : query,
        });

        this.inputSearchRef.current.clearInput();

        await this.setChannelsList(value);
    }

    onDateChange = async(tabName) => {
        const currentDate = this.state.dateList
            .filter(({ tabTitle }) => tabTitle === tabName)[0];

        this.setState(() => ({
            currentDate: currentDate.start,
            scheduleList: {},
        }), this.updateSchedule);
    }

    onTimeChange = (timeIntervals) => {
        const currentTimeInterval = Object.keys(timeIntervals)
            .filter((index) => timeIntervals[index] === true);
        let time = null;

        if (currentTimeInterval.length > 0) {
            time = currentTimeInterval[0];
        }

        this.setState(() => ({
            scheduleList: {},
            time,
        }), this.updateSchedule);
    }

    onSearchSelect = (searchItem) => {
        if (searchItem.chid === undefined) {
 return;
}

        const searchChannelsList = this.state.channelsList
            .filter(({ chid }) => chid === searchItem.chid);

        this.setState({
            channelsListRendered: searchChannelsList,
            isSearch: true,
        }, this.updateSchedule);
    }

    onSearchClear = () => {
        this.setState(({ channelsList }) => {

            return {
                ...channelsState(channelsList),
                isSearch: false,
            };
        }, this.updateSchedule);
    }

    lazyLoad = () => {
        if (this.isUpload === true) {
 return;
}

        this.setState(({ channelsListRendered, channelsList }) => {
            const channelsCount = channelsListRendered.length;
            const newChannels = channelsList.slice(channelsCount, channelsCount + CHANNELS_COUNT);
            const newChannelsRendered = [
                ...channelsListRendered,
                ...newChannels,
            ];

            const channelsDifference = channelsList.length - newChannelsRendered.length;

            return {
                channelsDifference,
                channelsListRendered: newChannelsRendered,
            };
        }, this.updateSchedule);
    }

    onWindowResize = () => {
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;

        if (isMobile !== this.isMobile) {
            this.isMobile = isMobile;

            if (isMobile) {
                window.removeEventListener('scroll', this.onWindowScroll);
            } else {
                window.addEventListener('scroll', this.onWindowScroll);
            }
        }
    }

    onWindowScroll = () => {
        if (this.isUpload === true || this.state.channelsDifference === 0 || this.state.isSearch === true) {
 return;
}

        const scrollY = window.scrollY === undefined ? document.documentElement.scrollTop : window.scrollY;
        const containerTop = this.scheduleContainer.current.getBoundingClientRect().top;
        const scrollBottom = document.documentElement.scrollHeight - scrollY - window.innerHeight;

        const containerBottom = containerTop + scrollY;
        if (scrollBottom - containerBottom < 150) {
            this.lazyLoad();
        }
    }

    render() {
        const { className, host, city, categoriesList } = this.props;
        const { channelsListRendered, scheduleList, dateList, time, channelsDifference, isSearch, channelsList, category } = this.state;
        const scheduleChannelsList = channelsListRendered
            .map((channel, index) => (
                <ChannelCommon
                    broadcasts={scheduleList[channel.xvid]}
                    key={channel.title + index}
                    logo={`${process.env.EPG_API_ENDPOINT}${channel.logo}`}
                    title={channel.title}
                    description={channel.description}
                    id={channel.chid}
                    scheduleContainer={this.scheduleContainer}
                    button={channel.button}
                />
            ));

        let tabsContainer = null;
        if (dateList.length > 0) {
            const tabs = dateList.map((date) => (
                <Tab key={date.tabTitle} label={date.tabTitle}>
                    <Filter
                        items={[
                            { label: 'Утро', value: 'morning', checked: time === 'morning' },
                            { label: 'День', value: 'afternoon', checked: time === 'afternoon' },
                            { label: 'Вечер', value: 'evening', checked: time === 'evening' },
                        ]}
                        name='timesOfDate'
                        onChange={this.onTimeChange}
                    />
                    <ScheduleChannels>
                        {scheduleChannelsList}
                    </ScheduleChannels>
                </Tab>
            ));

            tabsContainer = (
                <ScheduleTabs>
                    <Tabs activeTab={dateList[2].tabTitle} onSwitchTab={this.onDateChange}>
                        {tabs}
                    </Tabs>
                </ScheduleTabs>
            );
        }

        let showMoreButton = null;
        if (channelsDifference > 0 && isSearch === false) {
            showMoreButton = (
                <ScheduleShowMore type='secondary' onClick={this.lazyLoad}>
                    Показать еще {channelsDifference >= CHANNELS_COUNT ? CHANNELS_COUNT : channelsDifference} каналов
                </ScheduleShowMore>
            );
        }

        return (
            <Layout
                className={className}
                withMenu={true}
                withHeader={true}
                withChat={true}
                relCanonical={`https://${host}/domru-tv/program`}
                title={`Программа передач на сегодня в ${city.cityIn} от Дом.ru`}
                description={`Телепрограмма на сегодня, завтра и ближайшую неделю от Дом.ru в ${city.cityIn}. Всегда актуальное онлайн расписание ТВ-передач всех популярных телеканалов.`}
            >

                <SchedulePage>
                    <PageBanner city={city.cityIn} />

                    <ScheduleContainer ref={this.scheduleContainer}>
                        <ScheduleControls>
                            <ScheduleControlSearch>
                                <ChannelSearch
                                    items={channelsList.map(channel => ({
                                        chid: channel.chid,
                                        id: channel.chid,
                                        logo: `${process.env.EPG_API_ENDPOINT}${channel.logo}`,
                                        title: channel.title,
                                    }))}
                                    onSearch={this.onSearchSelect}
                                    onClearSearch={this.onSearchClear}
                                    placeholder='Поиск по каналам'
                                    ref={this.inputSearchRef}
                                />
                            </ScheduleControlSearch>
                            <ScheduleControlCategory>
                                <NoSSR>
                                    <Select
                                        defaultValue={categoriesList.find(i => i.value === this.props.category.toString())}
                                        value={categoriesList.find(i => i.value === category.toString())}
                                        options={categoriesList}
                                        onChange={this.onCategoriesChange}
                                        placeholder='Категории каналов'
                                    />
                                </NoSSR>
                            </ScheduleControlCategory>
                        </ScheduleControls>

                        {tabsContainer}
                        {showMoreButton}
                    </ScheduleContainer>
                </SchedulePage>
            </Layout>
        );
    }
}

const mapStateToProps = state => ({
    city: state.city.currentCity,
});

export default withRouter(connect(mapStateToProps)(Schedule));
